import type { TasProgramTemplateExtension as TasProgramTemplateModel } from 'tio-data/data/resources/tas-program-template.ext';
import type { DynamicEligibility, PeriodOfEligibility } from '../../types/tuition-assistance.ts';

export function filterEligibleTemplates(
  templates: TasProgramTemplateModel[],
  dynamicEligibility: DynamicEligibility,
  programEligibility: PeriodOfEligibility
) {
  const today = new Date();

  return templates.filter((template) => {
    const code = template.code;

    if (!dynamicEligibility[code]) {
      return false;
    }

    const periods = programEligibility[code];

    // Ensure periods exist and are not empty
    if (!periods || periods.length === 0) {
      return false;
    }

    const lastPeriod = periods[periods.length - 1];
    if (!lastPeriod || lastPeriod.length < 2) {
      return false;
    }

    const startDate = new Date(lastPeriod[0]!);
    const endDate = new Date(lastPeriod[1]!);

    // Ensure startDate and endDate are valid dates
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      return false;
    }

    return today >= startDate && today <= endDate;
  });
}

export default null; // silence a false warning
